import { useSubGoals as _useSubGoals } from '@griply/hooks';
import { useEntityLinks } from 'shared/hooks/use-entity-links';
import { ID } from 'shared/types/id';

import { useGoals } from './use-goals';

export const useSubGoals = (id?: ID, recursive = false) => {
  const goals = useGoals();
  const links = useEntityLinks();

  return _useSubGoals(id, { goals, links, recursive });
};
